import { useQuery } from "@tanstack/react-query";
import { FEED_QUERY_KEYS } from "../queryKeys";
import { fetchTags } from "../services/tags.service";

export const useTags = () => {
  return useQuery({
    queryKey: FEED_QUERY_KEYS.tags(),
    queryFn: () => fetchTags(),
  });
};
